import './plugins/bootstrap'
import App from './professional-projects/MomentoAllInOneProductFocus/momentoAllInOneProductFocus.vue'
import Vue from 'vue'
// Nespresso components
import VueLanding from 'nespresso-components/landing/VueLanding'
import Tracking from 'nespresso-library/src/core/tracking'
// Gvue Components
import Zone from 'gvue/src/core/Zone'
import Heading from 'gvue/src/core/Heading'
import Paragraph from 'gvue/src/core/Paragraph'
import Cta from 'gvue/src/core/Cta'
import Popin from 'gvue/src/core/Popin'
import EmbedVideo from 'gvue/src/core/EmbedVideo'

Vue.component('Zone', Zone)
Vue.component('Heading', Heading)
Vue.component('Paragraph', Paragraph)
Vue.component('Cta', Cta)
Vue.component('Popin', Popin)
Vue.component('EmbedVideo', EmbedVideo)

Vue.config.productionTip = false

const main = ({ App, trackingLabel, centralLandingAlias }) => {
    const trackingLabelTxt = 'B2B - LP - ' + trackingLabel
    Vue.use(VueLanding, {
        project: 'b2b',
        landing: 'MomentoAllInOneProductFocus',
        centralLandingAlias,
        trackingLabelPrefix: trackingLabelTxt,
        skipMutationKeys: [
            'link',
            'link_mobile',
            'param',
            'tracking',
            'capsules',
            'ctaLink'
        ],
        additionalBrands: [],
        sectionTrackingLabels: {
            hero: ' ',
            moreMachines: '25',
            machineSlider: ' ',
            paymentOptions: '50',
            maintenanceAlternatives: ' ',
            compare: '75',
            moreInfo: '100'
        }
    })
    Tracking.globalTracking(trackingLabelTxt)

    return new Vue({
        el: '#agilityApp',
        render: h => h(App)
    })
}

main({
    App,
    trackingLabel: 'Momento All In One Product Focus',
    centralLandingAlias: 'MomentoAllInOneProductFocus'
})
